import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// App Check removed - was causing 403 errors and blocking uploads


const rootElement = document.getElementById('root');

if (!rootElement) {
  // console.error('CRITICAL: No root element found in HTML!');
  document.body.innerHTML = '<div style="color: red; padding: 20px;">Error: No root element found. Check public/index.html</div>';
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
  // console.log('ReactDOM root created');
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
  } catch (error: any) {
  // console.error('Error rendering app:', error);
    rootElement.innerHTML = `<div style="color: red; padding: 20px;">Error rendering app: ${(error as any).message}</div>`;
  }
}